<template>
  <div class="header">
    <img :src="logo" :alt="companyInformation.logo_name" class="logo" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'ChatHeader',
  props: {
    logo: String,
    title: String,
    companyInformation: Object
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  display: grid; 
  place-items: center;
}

.logo {
  height: 5rem;
  margin-right: 0.83em;
}

.title {
  font-size: 1.69rem;
  font-family: TT Ramillas Trl, Inter, sans-serif;
  font-weight: 600;
}

.plus-badge {
  font-size: 0.6vw;
  background-color: #E6E8EA;
  border-radius: 4px;
  padding: 0.2vw 0.4vw;
  margin-left: 0.4vw;
}
</style>
